import exp from "constants";
import { CgCreate, CgCreateProps } from "../../components/common";
import { useNotify, useRedirect, useTranslate } from "react-admin";
import useRoles from "./useRole";
import { Resources } from "../resource";
import RoleForm from "./RoleForm";


const CreatePopup = (props: CgCreateProps & { selectedId: string, onRefresh: any }) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const t = useTranslate();
    const { onRefresh, ...rest } = props;

    const onSuccess = () => {
      const currentUrl = window.location.href;
      const origin = window.location.origin;
      const redirectValue = currentUrl.replace(origin, '');
      notify(t('module.roles.createSuccess'), { type: 'success', autoHideDuration: 1000 });
  
      if (props.onClose) {
        props.onClose();
      }
      if (props.onRefresh) {
        props.onRefresh();
      }
      // redirect(redirectValue);
    };
  
    const onError = (error: any) => {
      const errorCode = error?.body?.code;
      
      const notifyError = (msg: string) => {
        notify(msg, { type: 'error' });
      };
      notifyError(error?.body?.message || error?.message || t('module.roles.createError'));
    };
  
    return (
      <CgCreate
        {...rest}
        title="module.roles.createRole"
        resource={Resources.roles}
        mutationOptions={{
          onSuccess,
          onError,
        }}
        transform={(data) => {
          if (props.selectedId !== 'root') {
            return {
              ...data,
              parentId: props.selectedId,
            };
          }
          return {
            ...data
          };
        }}
      >
        <RoleForm isCreate />
      </CgCreate>
    );
};
export default CreatePopup;